import { ReactElement } from 'react'
import SceneLineMarker from '../SceneLineMarker'

interface Props {
  point: { x: number; y: number; z: number }
  size?: number
}

/**
 * Blue crosshair through `point`, mirroring DrawController's own ortho-snap
 * indicator (`xOrthoHelperRef`/`yOrthoHelperRef`) so a drag that snapped onto
 * another item's horizontal/vertical alignment line gets the same feedback.
 */
const OrthoSnapIndicator = ({ point, size = 2000 }: Props): ReactElement => (
  <SceneLineMarker
    lines={[
      [
        { x: point.x - size, y: point.y, z: point.z },
        { x: point.x + size, y: point.y, z: point.z },
      ],
      [
        { x: point.x, y: point.y - size, z: point.z },
        { x: point.x, y: point.y + size, z: point.z },
      ],
    ]}
    color="blue"
    lineWidth={1}
  />
)

export default OrthoSnapIndicator
